export default __webpack_public_path__ + "static/media/varsovie.2bdc5dc3.png";